"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./charts/charts"));



//////////////////
// WEBPACK FOOTER
// /app/~/ng2-charts/index.js
// module id = ../../../../ng2-charts/index.js
// module chunks = 7